// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"211":"editor-styles","869":"styles"}[chunkId] + ".css";
};